import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Loader } from "@components/Loader";
import { Routes, StorageKey } from "@ctypes";
import { useFetchFeatureFlags, useFetchUser, useLoginWithOAuth } from "@hooks";
import { Authentication } from "@services";
import { getQueryParams } from "@utils";

export const OAuthCallbackRoute = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const [loginWithOAuth] = useLoginWithOAuth();
  const [fetchUser] = useFetchUser();

  const [fetchFeatureFlags] = useFetchFeatureFlags();

  const params = getQueryParams(location.search);

  useEffect(() => {
    (async () => {
      if (params.token) {
        const response = await Authentication.authenticate(params.token as string);

        const jwtToken = response.session_jwt;

        await loginWithOAuth({
          variables: {
            jwt: jwtToken,
          },
        });

        if (jwtToken) {
          localStorage.setItem(StorageKey.Token, jwtToken);

          const [{ data: user }, { data: featureFlags }] = await Promise.all([
            fetchUser(),
            fetchFeatureFlags(),
          ]);

          localStorage.setItem(StorageKey.User, JSON.stringify(user));
          localStorage.setItem(StorageKey.FeatureFlags, JSON.stringify(featureFlags));
        }
      }
      navigate(Routes.Default, { replace: true });
    })();
  }, []);

  return <Loader />;
};
